import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../SecurityConfig/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const { setLoginDetails } = useContext(AuthContext);
  const location = useLocation();
  const handleLogout = () => {
    localStorage.clear();
    setLoginDetails({
      isAuthenticated: false,
      email: null,
      jwt: null,
      role: null,
    });
    navigate('/lessonplanner/signin');
  };

  return (
    <AppBar position="static" color="default" elevation={2}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, color: '#1976d2', fontWeight: 'bold' }}>
          Guntech School Portal
        </Typography>
        <Box>
        {location.pathname=='/lessonplanner/dashboard'  && <Button color="primary" variant="outlined" onClick={handleLogout}>
            Logout
          </Button>
        }
       {(location.pathname=='/lessonplanner/signin' || location.pathname=='/lessonplanner/signup') && <Button color="primary" variant="outlined" onClick={
        () => navigate('/')
       }>
           Home
          </Button>
       }
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;